import request from '@/router/axios';

export const getList = (current, size, params) => request({
  url: '/api/mcc-staff/processEvection/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export const update = params => request({
  url: '/api/mcc-staff/processEvection/update',
  method: 'post',
  data: params,
})

export const exportExcel = params => request({
  url: '/api/mcc-staff/processEvection/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

export const getDetail = (params) => request({
  url: '/api/mcc-staff/processEvection/detail',
  method: 'get',
  params: {
    ...params
  },
})
export default {}
